import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import "./NavigationItems.css";
import "./courses.css";

function ServicesContainer(props) {
  return (
    <>
      <div id="coursesPage" className="page">
        <h1>Courses</h1>
        <hr />
        {props.isAuth && (
          <Button design="raised" mode="accent" onClick={props.onAddCourse}>
            New course
          </Button>
        )}
        <ul id="courses-items">{props.children}</ul>
      </div>
    </>
  );
}

export default ServicesContainer;
